// components/Expand.tsx
import React from 'react';
import { FC, ReactNode, useRef, useState, useEffect } from 'react';

interface ExpandProps {
  /** 애니메이션 지속 시간 (ms) */
  duration?: number;
  /** 시작 전 지연 시간 (ms) */
  delay?: number;
  /** 추가 클래스네임 */
  className?: string;
  /** 펼쳐질 자식 컴포넌트 */
  children: ReactNode;
}

/**
 * Expand
 * - 단일 책임: 자식 요소를 0 → 본래 높이로 확장
 * - 확장성: duration, delay, className을 props로 열어두어 언제든 커스터마이징 가능
 */
const Expand: FC<ExpandProps> = ({
  children,
  duration = 500,
  delay = 0,
  className = '',
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (ref.current) {
      // 마운트 직후 실제 scrollHeight를 측정
      setHeight(ref.current.scrollHeight);
      // 다음 렌더 사이클에서 expanded=true로 바꿔 트랜지션 시작
      requestAnimationFrame(() => setExpanded(true));
    }
  }, []);

  return (
    <div
      ref={ref}
      className={`overflow-hidden transition-[max-height] ease-in-out ${className}`}
      style={{
        maxHeight: expanded ? `${height}px` : '0px',
        transitionDuration: `${duration}ms`,
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default Expand;
